import { render } from "./App.vue?vue&type=template&id=35f0578a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=35f0578a&lang=scss"
script.render = render

export default script